/** Celular digitado com máscara, mais o DDI do país, no formato +5548999998888. */
export default function formatPhoneToE164(phone: string, countryCode: string) {
  return `+${countryCode.replace(/\D/g, '')}${phone.replace(/\D/g, '')}`;
}
